import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from "./router";
import store from "./state/store";
import { useLocaleStore } from './stores/locale';
import { useAuthStore } from './stores/auth';

import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska";
import VueFeather from 'vue-feather';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import './assets/scss/app.scss';
import '@vueform/slider/themes/default.css';
import 'bootstrap/dist/js/bootstrap.bundle';

AOS.init({
  easing: 'ease-out-back',
  duration: 1000,
});

const pinia = createPinia();

const app = createApp(App);

app.use(pinia);
app.use(store);
app.use(router);
app.use(VueApexCharts);
app.use(BootstrapVueNext);
app.component(VueFeather.type, VueFeather);
app.directive("maska", vMaska);
app.use(i18n);
app.use(VueSweetalert2);
app.use(vClickOutside);

app.mount('#app');

// Initialize locale (RTL/LTR direction)
const localeStore = useLocaleStore();
localeStore.initLocale();

// Refresh admin session when token exists
const authStore = useAuthStore();
if (authStore.token) {
  authStore.fetchMe();
}